(function($){
    var getContainerForInput = function (elem) {
        var $container = $(elem).parents('.form__question');
        return $container;
    };

    var options = {
        errorElement: 'span',
        errorClass:   'form__error-message',

        errorPlacement: function (error, element) {
            var $container = $(element).parents('.form__answer');
            $container.append(error);
        },

        // fn((element, errorClass, validClass))
        highlight: function (element) {
            getContainerForInput(element).addClass('form__error');
        },

        // fn element, errorClass, validClass)
        unhighlight: function (element) {
            getContainerForInput(element).removeClass('form__error');
        },
    };

    // Some forms have slightly different submission rules and confirmation messages
    // For resources we return the visitor straight to the PDF URL
    // For on demand webinars we must display the webinars
    // For all others we simply display an appropriate confirmation message on the page
    $.each($('.mktoForm'), function(index, form) {
        var addOption = false;
        var type      = '';
        var message   = '';
        var formid = $(form).find('input[name=formid]').val();
        // Let the submission go straight to Marketo and return the user directly to the PDF
        // .form__resource--download returns the visitor to the page to the PDF
        // .form__resource--webinar returns the visitor to the page to view the webinar
        if ($(form).hasClass('form__resource--download') || $(form).hasClass('form__resource--webinar')) {
            addOption = true;
            type      = 'submit';
        } else if ($('.form__event').length > 0) {
            addOption = true;
            type      = 'event';
            message   = 'Thanks for registering! A confirmation email will be sent to you shortly.'
        } else if ($('.form__training').length > 0) {
            // Training form
            addOption = true;
            type      = 'training';
            message   = 'Thanks for your enquiry. Someone from our training team will be in touch shortly.'
        } else if ($('.form__modal').length > 0) {
            // Form in modal
            addOption = true;
            type      = 'modal__contact-form';
            message   = 'Thank you for your enquiry. Someone will be in touch shortly.'
        } else {
            // Contact Us page or Footer contact form
            addOption = true;
            type      = 'contact';
            message   = 'Thank you for your enquiry. Someone will be in touch shortly.'
        }

        if (addOption === true) {

            options.submitHandler = function(form) {

                $(form).find('input[name="Referer"]').attr('value', document.referrer);
                $(form).find('input[name="LeadSystemInfo"]').attr('value', navigator.userAgent);

                if (type === 'submit') {
                        form.submit();
                    } else {

                        var mktoSys = '//app-sn02.marketo.com';
                        var munchkinID = '255-DNB-634';

                        // load a hidden Marketo Form 2.0 to submit to the Marketo system
                        MktoForms2.loadForm(mktoSys, munchkinID, formid, function(mktoForm) {

                            // get the value of all fields in the form
                            var fields = {};
                            $(form).find('input, select, textarea, checkbox').each(function() {
                                fields[$(this).attr("name")] = $(this).val();
                            });
                            // add them to the hidden Marketo Form 2.0
                            mktoForm.addHiddenFields(fields);
                            mktoForm.onSubmit(waitForSubmission(form));
                            mktoForm.submit();
                            mktoForm.onSuccess(function() {
                                // hide the form and show a confirmation message
                                confirmSubmission(form, message);

                                return false;

                            });

                        });

                    } //end if
            };

            $(form).validate(options);
        }//end if

        function confirmSubmission(form, message) {
            $(form).slideUp(1500, 'swing', function() {
                if ( type == 'modal__contact-form' ) {
                    var $messageTarget = $('#form__description.modal__form-description');
                } else {
                    var $messageTarget = $('#form__description');
                }
                $messageTarget.fadeOut(function() {
                    $messageTarget.text(message);
                    $messageTarget.fadeIn();
                });
            });
        }

        function waitForSubmission(form) {
            $(form).children('.form__submit').addClass('form__submit--waiting');
        }

    });


}(jQuery));


(function($) {
    // State/Province selector
    var codes = {};
    codes['United States'] = {
        AK: 'Alaska',
        AL: 'Alabama',
        AR: 'Arkansas',
        AZ: 'Arizona',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DC: 'District of Columbia',
        DE: 'Delaware',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        IA: 'Iowa',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        MA: 'Massachusetts',
        MD: 'Maryland',
        ME: 'Maine',
        MI: 'Michigan',
        MN: 'Minnesota',
        MO: 'Missouri',
        MS: 'Mississippi',
        MT: 'Montana',
        NC: 'North Carolina',
        ND: 'North Dakota',
        NE: 'Nebraska',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NV: 'Nevada',
        NY: 'New York',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VA: 'Virginia',
        VT: 'Vermont',
        WA: 'Washington',
        WI: 'Wisconsin',
        WV: 'West Virginia',
        WY: 'Wyoming'
    };
    codes.Canada = {
        AB: 'Alberta',
        BC: 'British Columbia',
        MB: 'Manitoba',
        NB: 'New Brunswick',
        NF: 'Newfoundland',
        NT: 'Northwest Territories',
        NS: 'Nova Scotia',
        NU: 'Nunavut',
        ON: 'Ontario',
        PE: 'Prince Edward Island',
        QC: 'Quebec',
        SK: 'Saskatchewan',
        YT: 'Yukon Territory'
    };
    codes.Australia = {
        ACT: 'Australian Capital Territory',
        NSW: 'New South Wales',
        NT:  'Northern Territory',
        QLD: 'Queensland',
        SA:  'South Australia',
        TAS: 'Tasmania',
        VIC: 'Victoria',
        WA:  'Western Australia'
    };

    var labels = {};
    labels['United States'] = 'State';
    labels.Australia = 'State/Territory';
    labels.Canada = 'Province';

    // Hide a question element based on it's input/select $elem
    function hideQuestion($elem) {
        $elem.parents('.form__question').find('.form__label, .form__answer').hide();
    }

    // Show a question element based on it's input/select $elem
    function showQuestion($elem) {
        $elem.parents('.form__question').find('.form__label, .form__answer').show();
    }

    // Set the state select options
    function setSelectOptions($country, $select, $form) {
        var code = $country.val();
        $select.empty();

        if (codes.hasOwnProperty(code) && labels.hasOwnProperty(code)) {
            $form.find('label[for="'+$select.attr('id')+'"]').text(labels[code]);
            $select.append('<option value="" selected>Select '+labels[code]+'</option>');
            $.each(codes[code], function(stateCode, stateName) {
                $select.append('<option value="'+stateCode+'">'+stateName+'</option>');
            });
            $select.attr('disabled', false).attr('required', true).attr('aria-required', true);
            showQuestion($select);
        } else {
            $form.find('label[for="'+$select.attr('id')+'"]').text('State');
            $select.attr('disabled', true).attr('required', false).attr('aria-required', false);
            hideQuestion($select);
        }
    }

    $('.state-select').each(function() {
        var $select = $(this);
        var $form = $select.parents('form');
        var $country = $form.find('.country-select');

        if (!$country.length) {
            return;
        }

        hideQuestion($select);

        $country.on('change', function() {
            setSelectOptions($(this), $select, $form);
        });

        $(document).on('ready', function() {
            setSelectOptions($country, $select, $form);
        });
    });

    // Training course pages have multiple forms on them
    // Apply incremental tabindex to all fields on the page for better usability for JS-enabled browsers

    if($('.training-child').length > 0) {
        var tabindex = 1;
        $('input,select,textarea,button[type=submit]').each(function() {
            var $input = $(this);
            if ($input.type !== "hidden") {
                $input.attr("tabindex", tabindex);
                tabindex++;
            }
        });
    }

}(jQuery));
